/*
 * サブシステム名：マスタ管理
 * 機能名：ETC利用サイト設定一覧
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdListResult from '@/components/DdListResult'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

import date from '@/ddv2.library/date'

export default {
  name: 'MstEtcRiyouList',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    expansionPanel: [0, 1],
    conditions: {},
    CreateButtonDisp: false,
    modalId: 0,
    modalFlg: false
  }),
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdListResult
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isShowCreateButton () {
      return this.CreateButtonDisp
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        // loadMasters: ['msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('EtcRiyouJohoList.defineHeaderPromise')
            self.headers = [
              // { text: 'No', value: 'id' },
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp' },
              { text: 'ログインID', value: 'etcRiyoshaLoginId' },
              // { text: 'パスワード', value: 'etcRiyoshaPassword' },
              // { text: 'パスワード', value: 'etcRiyoshaPasswordDisp' },
              { text: 'メモ', value: 'memo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              hacchakuchiCd: '',
              hacchakuchiNm: '',
              torihikisakiCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('EtcRiyouJohoList.savedInputRestorePromise', c)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('EtcRiyouJohoList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('EtcRiyouJohoList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('EtcRiyouJohoList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('EtcRiyouJohoList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            self.CreateButtonDisp = kengen.kengenValue !== 50

            self.onSearchButtonClick()
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/MstEtcRiyouJoho/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('EtcRiyouJohoList.clearInputsPromise')
            this.conditions = {
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            this.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/MstEtcRiyouJoho/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvdownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = 'ETCサイト利用設定_' + ts + '.csv'
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
